import CircularProgress from '@mui/material/CircularProgress'

export const Progress = () => {
  return <CircularProgress aria-label='Loading…' color='inherit' size='1.6rem' thickness={5} />
}
